if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let requestData = formData;

        // Find the T42 filter selector in this product's section.
        const picker = this.closest('product-info')
          ?.querySelector('[data-t42-filter-picker]');

        if (picker) {
          const selects = [
            ...picker.querySelectorAll('[data-t42-filter]')
          ];

          const ids = selects.map(select => select.value);

          // Validate four different, available filters.
          const valid =
            selects.length === 4 &&
            ids.every(Boolean) &&
            new Set(ids).size === 4 &&
            selects.every(select => {
              const option = select.selectedOptions[0];
              return option &&
                !option.disabled &&
                option.dataset.available === 'true';
            });

          const error = picker.querySelector('[data-t42-error]');

          if (!valid) {
            if (error) error.hidden = false;

            this.handleErrorMessage(
              'Please select four different, available filter modules.'
            );

            // Reset Dawn's loading state.
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner')
              ?.classList.add('hidden');

            return;
          }

          if (error) error.hidden = true;

          const kitId = formData.get('id');
          const quantity = Number(formData.get('quantity')) || 1;

          // Replace the ordinary single-product request
          // with a request containing all five variants.
          requestData = new FormData();

          // Item 0: T42 Mini
          requestData.append('items[0][id]', kitId);
          requestData.append('items[0][quantity]', String(quantity));

          // Preserve Shopify selling plans and line-item properties.
          // This includes standard preorder selling plans.
          for (const [key, value] of formData.entries()) {
            if (key === 'selling_plan' && value) {
              requestData.append('items[0][selling_plan]', value);
            } else if (
              key.startsWith('properties[') &&
              key.endsWith(']')
            ) {
              requestData.append(`items[0][${key}]`, value);
            }
          }

          // Items 1-4: the selected filter modules.      
          ids.forEach((id, index) => {
            const itemIndex = index + 1;

            requestData.append(
              `items[${itemIndex}][id]`, id
            );

            requestData.append(
              `items[${itemIndex}][quantity]`, String(quantity)
            );

            // Attach this filter module to the T42 Mini.
            requestData.append(
              `items[${itemIndex}][parent_id]`, kitId
            );

            requestData.append(
              `items[${itemIndex}][properties][_Included with]`,
              'T42 Mini'
            );
          });

          console.log('[T42] Adding kit and filter modules:', {
            kitId,
            quantity,
            filterVariantIds: ids
          });
        }

        // Preserve Dawn's existing cart drawer integration.
        if (this.cart) {
          requestData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );

          requestData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = requestData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
